<div class="surface-card">
    <div class="section-label float-events-title">Float Engine Audit Log</div>

    @if (isInaccessible) {
        <div class="float-events-placeholder">
            <span class="data-unavailable">You do not have access to float activity</span>
        </div>
    } @else if (isUnavailable) {
        <div class="float-events-placeholder">
            <span class="data-unavailable">{{ unavailableMessage ?? 'Float activity is currently unavailable' }}</span>
        </div>
    } @else if (isFirstLoad) {
        <div class="float-events-placeholder">
            <span class="data-unavailable">Loading float activity</span>
        </div>
    } @else if (isEmpty) {
        <div class="float-events-placeholder">
            <span class="data-unavailable">No float activity</span>
        </div>
    } @else {
        <div class="table-responsive">
            <table class="table table-hover float-events-table">
                <thead>
                <tr>
                    <th scope="col">Timestamp</th>
                    <th scope="col">Event</th>
                    <th scope="col">Reference</th>
                    <th class="float-events-numeric" scope="col">Amount</th>
                    <th class="float-events-numeric" scope="col">Balance After</th>
                </tr>
                </thead>
                <tbody>
                    @for (operation of operations; track $index) {
                        @let credit = isCredit(operation);
                        <tr>
                            <td class="float-events-timestamp">{{ operation.operationDateTime | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}</td>
                            <td>
                                <span class="float-events-event">
                                    <span [class]="'float-events-dot ' + eventDotModifier(operation)"
                                          aria-hidden="true"></span>{{ eventLabel(operation) }}
                                </span>
                                @if (operation.description) {
                                    <span class="float-events-description">{{ operation.description }}</span>
                                }
                            </td>
                            <td class="float-events-reference">{{ operation.operationKey }}</td>
                            <td [class.float-events-credit]="credit"
                                [class.float-events-debit]="!credit"
                                class="float-events-numeric">
                                {{ credit ? '+' : '−' }}{{ operation.amountCents | toMajor | currency:'ZAR':'R ' }}
                            </td>
                            <td class="float-events-numeric float-events-balance">
                                {{ operation.balanceAfterOperation?.balance | toMajor | currency:'ZAR':'R ' }}
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>

        <div aria-live="polite" class="float-events-status">
            @if (loading) {
                <span class="data-unavailable">Loading more float activity</span>
            } @else if (pageTokenRejected) {
                <span class="data-unavailable">This list is out of date. Start again to see the latest activity.</span>
            } @else if (loadFailed) {
                <span class="data-unavailable">{{ unavailableMessage ?? 'Could not load more float activity' }}</span>
            }
        </div>

        @if (pageTokenRejected) {
            <div class="float-events-actions">
                <button (click)="restart()"
                        class="btn btn-outline-primary float-events-load-more"
                        type="button">
                    Start Again
                </button>
            </div>
        } @else if (hasMore) {
            <div class="float-events-actions">
                <button (click)="loadMore()"
                        [disabled]="loading"
                        class="btn btn-outline-primary float-events-load-more"
                        type="button">
                    Load More
                    @if (loading) {
                        <i aria-hidden="true" class="fa fa-spinner fa-spin"></i>
                    }
                </button>
            </div>
        }
    }
</div>
